const instagramConnectHelpLink = 'https://www.godaddy.com/help/connect-instagram-account-to-facebook-page-32230';

export {
  instagramConnectHelpLink
};
